import { useEffect, useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { Target, Gavel } from "lucide-react";
import { API, err, useH } from "@/components/crm/tl/shared";
import { Ziele } from "@/components/crm/gf/Ziele";
import { Beschluesse } from "@/components/crm/gf/Beschluesse";

export default function CRMGeschaeftsfuehrung() {
  const { H } = useH();
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") === "beschluesse" ? "beschluesse" : "ziele";
  const [stamm, setStamm] = useState(null);
  const [ziele, setZiele] = useState([]);
  const [beschluesse, setBeschluesse] = useState([]);
  const load = useCallback(() => Promise.all([axios.get(`${API}/gf/stamm`, H), axios.get(`${API}/gf/ziele`, H), axios.get(`${API}/gf/beschluesse`, H)]).then(([s, z, b]) => { setStamm(s.data); setZiele(z.data); setBeschluesse(b.data); }).catch(err), []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [load]);
  const wechsel = (t) => { const p = new URLSearchParams(params); p.set("tab", t); setParams(p, { replace: true }); };
  if (!stamm) return <p className="text-sm text-slate-500">Lädt …</p>;
  return (
    <div className="space-y-3" data-testid="crm-gf">
      <div className="flex items-center gap-2 sm:gap-3">
        <div className="h-9 w-9 sm:h-11 sm:w-11 rounded-xl bg-slate-900 text-white flex items-center justify-center shrink-0"><Target className="h-5 w-5" /></div>
        <div className="min-w-0"><h1 className="font-['Manrope'] text-lg sm:text-2xl font-bold text-slate-900 leading-tight">Geschäftsführungsplanung</h1><p className="hidden sm:block text-sm text-slate-500">Ziele, Meilensteine, Beschlüsse – nur für Admin-Zugänge sichtbar</p></div>
      </div>
      <div className="flex gap-2">{[["ziele", "Ziele & Timeline", Target], ["beschluesse", "Beschlüsse & Vereinbarungen", Gavel]].map(([k, l, I]) => <button key={k} onClick={() => wechsel(k)} className={`h-10 px-3 rounded-full text-sm font-semibold inline-flex items-center gap-1.5 ${tab === k ? "bg-slate-900 text-white" : "bg-white border border-slate-200 text-slate-600"}`} data-testid={`gf-tab-${k}`}><I className="h-4 w-4" />{l}</button>)}</div>
      {tab === "ziele" ? <Ziele stamm={stamm} ziele={ziele} onChanged={load} fokus={params.get("ziel")} /> : <Beschluesse stamm={stamm} ziele={ziele} beschluesse={beschluesse} onChanged={load} />}
    </div>
  );
}
